import { SxProps, Theme } from "@mui/material";

import { DATETIME_FORMATS } from "@/common/constants/common";
import { ResponsiveStyleValueCustom } from "@/theme/types";

import EntityChangedByInfoDisplay, { Entity } from "./EntityChangedByInfoDisplay";

export interface EntityUpdatedByInfoDisplayProps {
  entity: Entity | null | undefined;
  dateFormat?: string | null | undefined;
  direction?: ResponsiveStyleValueCustom<"row" | "column">;
  sx?: SxProps<Theme>;
}

/** Shows who updated the entity. */
export default function EntityUpdatedByInfoDisplay({
  entity,
  dateFormat = DATETIME_FORMATS.DISPLAY_DATETIME,
  direction,
  sx,
}: EntityUpdatedByInfoDisplayProps) {
  return (
    <EntityChangedByInfoDisplay
      dateFormat={dateFormat}
      datetime={entity?.updatedAt}
      userId={entity?.updatedBy}
      direction={direction}
      sx={sx}
    />
  );
}
